<template>
        <li>
            <div class="p-4 flex items-center group">
                <div class="mr-4 hidden sm:block">
                    <IconSpinner class="w-10 h-10"/>
                </div>
                <div class="grow animate-pulse">
                    <div class="mb-2 font-bold">
                        <span>
                            <WbLoaderBarSrc class="w-4/12 h-5"/>
                        </span>
                    </div>
                    <div>
                        <span>
                            <WbLoaderBarSrc class="w-2/12 h-5"/>
                            <WbLoaderBarSrc class="w-4/12 h-5"/>
                        </span>
                    </div>
                </div>
            </div>
        </li>
</template>
<script>
import IconSpinner from '../icons/IconSpinner.vue'
import WbLoaderBarSrc from '../sources/SrcLoaderBar.vue'

export default {
  name: 'CustomDropdown',
  components: {
    IconSpinner, WbLoaderBarSrc,
  },
}
</script>

